define('models/calendar/session/exercise/cardio/phase',[
    'underscore', 'backbone',
    // src
    'utils',
    // collections
    'collections/calendar/session/exercise/cardio/phase-weeks',
    // models
    'models/calendar/session/exercise/cardio/phase-week',
], function(
    _, Backbone, U,
    // collections
    CPhaseWeeks,
    // models
    MPhaseWeek
) {

    var MPhase = Backbone.Model.extend({
        defaults: {
            linkNext: false,
            name: "",
        },

        // validation: {
        //     reps: {
        //         presence: true,
        //         numericality: {
        //             onlyInteger: true,
        //             notInteger: "The number of repetitions must be a positive integer.",
        //             greaterThanOrEqualTo: 0,
        //             notGreaterThanOrEqualTo: "The number of repetitions must be a positive integer.",
        //         },
        //     }
        // },

        initialize: function(attrs, options) {

            var weeks = this.getWeeks();
            if (weeks.length === 0) {
                weeks.push(new MPhaseWeek());
            }
            if (!weeks.models) {
                this.set({ weeks: new CPhaseWeeks(weeks) });
            }

            // this.listenTo(this, "change:numSets", this.onNumSetsChange);

        },

        getWeek: function(weekIndex) {
            return this.getWeeks().at(weekIndex);
        },

        getWeeks: function() {
            return this.get('weeks');
        },

        toJSON: function(options) {
            var copy = MPhase.__super__.toJSON.call(this, options);
            if (_.has(copy, "weeks")) {
                copy.weeks = copy.weeks.toJSON(options);
            }
            return copy;
        },

        ////////////
        // events //
        ////////////
        onNumWeekChange: function(model, value, options) {
            this.getWeeks().onNumWeekChange(value);
        }

    });

    return MPhase;
});

